
class roomSetup {

	constructor(args)
		{
			if ( window.$Any ) { console.log('check 2222'); this.$ = window.$Any; console.log('check 333'); }
			this.usingTracker = false;
			this.currentUserData = JSON.parse(localStorage.getItem("userData"));
			this.whiteboardValues = this.currentUserData.whiteboardValues;
			this.onDemand = window['onDemand'];		
			this.guestUser = window['guestUser'];
			this.electron = window['electron'];
			this.sep = '~@$';
			this.id = args['user_id'];
			this.hostVirtual = false;
			this.hostVirtualOnMember = false;
			this.memberNoHostVirtual = false;
			this.hostVirtualReplay = false;
			
			if ( args['host_virtual'] )
				{
					this.hostVirtual = true;
					console.log('load host virtual');
				}
			
			if ( args['host_virtual_member'] )
				{
					this.hostVirtualOnMember = true;
				}
				
			if ( args['host_virtual_ondemand'] )
				{
					this.memberNoHostVirtual = true;
				}
			
			if ( args['host_virtual_replay'] )
				{
					this.hostVirtualOnMember = true;
					this.memberNoHostVirtual = true;
					this.hostVirtualReplay = true;
				}
				
			this.useMediaPipe = parseInt(this.whiteboardValues.useMediaPipe);
			this.workoutZoneSet = false;
			this.workoutTimerEnded = false;
			this.roomSetupCircleAdded = false;
			this.roomZoneSet = false;
			this.timerStarted = false;
			this.timerRunning = false;
			this.workoutAreaCirclePush = false;
			this.roomSetupCompleted = false;
			this.mediaCircleCompleted = false;
			this.roomStandingInCircle = false;
			this.roomStandingStarted = false;
			this.workoutCirclePosition = {};
			
			this.workoutRegionX = 0;
			this.workoutRegionW = 0;
			this.trackerData = '';
			this.startRecTime = (new Date()).getTime();
			this.mediaRecorder1 = '';
			this.nowCountRec = 0;
			this.partStandingX = 0;
			this.partStandingY = 0;
			this.roomSetupCanvas = '';
			this.ctx5 = '';
			this.firstRoomCircleX = 0;
			this.firstRoomCircleY = 0;
			this.secondRoomCircleX = 0;
			this.secondRoomCircleY = 0;
			this.workoutSpaceTimeout = false;
			this.wentInsideWorkout = false;
			this.newConesSize = {
				"newConeSmall": [76, 85],
				"newConeBig": [101, 111],
				"coneCircleSmall": [130, 44],
				"coneCircleBig": [172, 58]
			};
			this.workoutLineStartX = 0;
			this.workoutLineStartY = 0;
			this.workoutLineEndX = 0;
			this.workoutLineEndY = 0;
			this.workoutConeLocation = {};
			this.movementTimeoutStarted = false;
			this.firstPixelData = '';
			this.onCorrectSide = false;
			this.participantHeight = 1905;
			this.canvasWidthDiff = 2;
			this.workoutCurrentCone = 'topRight';
			this.lastStandingPosX = 0;
			this.lastStandingPosY = 0;
			this.lastStandingPosTop = 0;
			this.lastPosTime = 0;
			this.timeoutWorkoutArea = 0;
			this.canvasRatio = 1280 / 1000;
			this.canvasWidth = 1280;
			this.canvasHeight = 720;
			this.roomSetupCircles = {
				'first': {
					'startX' : this.canvasWidth/4 - (this.whiteboardValues.heightCircleW/2),
					'startY' : this.canvasHeight - 70 - 25,
					'w' : parseInt(this.whiteboardValues.heightCircleW),
					'h' : 70,
					'roomC': true,
					'whichC': 'first'
				},
				'second': {
					'startX' : this.canvasWidth - this.canvasWidth/4 - (this.whiteboardValues.heightCircleW/2),
					'startY' : this.canvasHeight - 70 - 25,
					'w' : parseInt(this.whiteboardValues.heightCircleW),
					'h' : 70,
					'roomC': true,
					'whichC': 'second'
				}
			};
			this.firstCircleShown = false;
			
			this.sessionDataStore = window.sessionDataStore;
			this.Util =  window.Util;
			
			if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual || (this.onDemand && !this.memberNoHostVirtual) || (this.hostVirtualReplay && !this.currentUserData.sessionData.ondemandId) )
				{
					window.createRoomSetupCanvas = this.createRoomSetupCanvas;
					window.finishRoomSetup = this.finishRoomSetup;
					window.finishMediaPipeCircle = this.finishMediaPipeCircle;
					window.startWorkoutAreaSetup = this.startWorkoutAreaSetup;
					window.finishWorkoutSetup = this.finishWorkoutSetup;
					window.updateWorkoutConeLocation = this.updateWorkoutConeLocation;
				}
				
			if ( this.memberNoHostVirtual )
				{	
					window.finishWorkoutSetupHost = this.finishWorkoutSetupHost;
				}
		}
	
	finishWorkoutSetup = () => 
		{
			if ( window['updateBagPosition'] ) { window['updateBagPosition'](this.id, window['bagPosition']); }
			let timeoutTime = 2000;
			let mainThis = this;
			this.workoutTimerStarted = false;
			this.timeoutWorkoutArea = 0;
			let act_type;
			let act_index = 0;
			if ( window['preStreamingWhite'] ) 
				{ 
					window['globalCurrentIndex'] = 0; 
					act_index = window['globalCurrentIndex']; 
					act_type = this.currentUserData.sessionData.scriptDetail[act_index]['attribute'][0]['attrValue'];
					this.$('#camera_cbx').addClass('camera_main_holder');
				}
			else
				{
					if ( !this.guestUser ) { act_index = window['currentActNum']-1; }
					else { act_index = window.currentIndex; }
					act_type = window['checkActivityType'](act_index);
				}
			
			clearInterval(mainThis.setWorkoutTimeout);
			//if ( window['audioType'] !== 'offAudio' ) { this.whiteboard.soundPlay.stopAudio(); this.whiteboard.soundPlay.playAudio('workoutAreaSetupDone2'); timeoutTime = 4000; }
			
			/* this.$('#upNextText').addClass('d-none');
			this.$('#partToolTip .tooltipSvg').addClass('d-none');
			this.$('#toolTip .tooltipSvg').addClass('d-none');
			this.$('#partToolTip .part_inner').html('');
			this.$('#toolTip .part_inner').html('');
			this.$('#partToolTip .tooltipSuccess').removeClass('d-none');
			this.$('#toolTip .tooltipSuccess').removeClass('d-none');
			this.$('.tooltipText').addClass('tool_tip_checkmark');
			this.$('.checkmark').addClass('checkmark_inline'); */
			//this.whiteboard.showMessageInstruction(this.globalEquipmentObject['workoutAreaSuccessMessage'], false);

			this.workoutProcessOver = true;
			this.compareStarted = false;
			this.workoutTimerEnded = true;
			
			if ( window['preStreamingWhite'] )
				{	
					window['usingPose'] = false;
				}
			
			setTimeout(function() {
				mainThis.$('#partToolTip').addClass('d-none');
				mainThis.$('#toolTip').addClass('d-none');
				mainThis.$('#partToolTip .tooltipSvg').addClass('d-none');
				mainThis.$('#toolTip .tooltipSvg').addClass('d-none');
				mainThis.$('#partToolTip .part_inner').html('');
				mainThis.$('#toolTip .part_inner').html('');
				mainThis.$('#partToolTip .tooltipSuccess').addClass('d-none');
				mainThis.$('#toolTip .tooltipSuccess').addClass('d-none');
				mainThis.$('.tooltipText').removeClass('tool_tip_checkmark');
				mainThis.$('.checkmark').removeClass('checkmark_inline');
				mainThis.$('#partToolTip .tooltipText').html('');
				mainThis.$('#toolTip .tooltipText').html('');
			}, 2000);	
			
			if ( window.roomSetupNextStep ) { window.roomSetupNextStep(); }
			
			setTimeout(function() {
				mainThis.roomSetDone = true;
				mainThis.viewCaptured = true;
				mainThis.workoutAreaSetupDone = true;
				mainThis.roomSetupInProgress = false;
				mainThis.workoutAreaAudioPlayed = false;
				mainThis.whiteboard.globalActType = mainThis.whiteboard.getActivityId(mainThis.whiteboard.currentActivityName);
				mainThis.whiteboard.doActivityEvents('activityBeforeStart');
				
				if ( window['preStreamingWhite'] && mainThis.guestUser )
					{
						console.log('timeee1');
						window.changeGlobalActType('', parseInt(mainThis.id));
					}
				else 
					{
						console.log('timeee2');
						window.changeGlobalActType(mainThis.whiteboard.globalActType, parseInt(mainThis.id));
					}
				
				if ( window['preStreamingWhite'] && !window.detectionDisabled )
					{
						window.enterSession();
					}
				else
					{
						if ( mainThis.guestUser && (( !window['participantRejoined'] && ( act_type != 'Virtual Equipment' && act_type != 'Virtual Assistant' ) || ( window['participantRejoined'] && !mainThis.retakeSetup ) ) ) )
							{
								setTimeout(function() {
									if ( mainThis.guestUser && window['streamSwapped'] && act_type != 'Virtual Equipment' && act_type != 'Virtual Assistant' ) { window['swapStreamVirtual'](true); }
								}, 2000);
							}
							
						if ( window.showHideRoomSetup ) { window.showHideRoomSetup(true); }
						if ( mainThis.currentUserData.sessionData.ondemandId > 0 ) { window.playVideo(); mainThis.$('.main_progress_container').removeClass('disabled'); }
						mainThis.$('.redo_button').removeClass('disabled');
					}
				
				for ( var b = 0; b < mainThis.whiteboard.canvasLines.length; b++ )
					{
						if ( mainThis.whiteboard.canvasLines[b]['conePos'] )
							{
								mainThis.whiteboard.canvasLines.splice(b, 1);
								
								b--;
							}
					}
					
				mainThis.whiteboard.sendDrawRTM(mainThis.currentUserData['sessionData']['hostEmail']);
				
				mainThis.workoutAreaProcess = false;
				if ( mainThis.onDemand ) 
					{
						window['onDemandWASDone'] = true;
						if ( mainThis.whiteboard.globalActType == "" )
							{
								if ( window.closeDrawing ) { window.closeDrawing(); }
								mainThis.$('#movedEquipmentDem').addClass('d-none');
							}
						else
							{
								mainThis.whiteboard.setStatsIcons();
								window['usingPose'] = true;
							}
						
						//window['endRoomSetup']();
					}
				window['participantRejoined'] = false;
			}, timeoutTime);
			
			var windowResolution = {
				'w': window.innerWidth, 
				'h': window.innerHeight
			};
			
			mainThis.workoutConeLocation['canvasSize'] = windowResolution;
			
			var flutterCanvas = document.querySelector('flt-glass-pane').shadowRoot.querySelector('canvas');
			var canvasWidthDiff = 1;
			var canvasHeightDiff = 1;
			
			if ( flutterCanvas.width < 1280 ) { canvasWidthDiff = flutterCanvas.width/1280; }
			if ( flutterCanvas.height < 720 ) { canvasHeightDiff = flutterCanvas.height/720; }
			
			mainThis.workoutConeLocation['topRight']['posY'] = mainThis.workoutConeLocation['topRight']['posY'] / canvasHeightDiff;
			mainThis.workoutConeLocation['topRight']['posX'] = mainThis.workoutConeLocation['topRight']['posX'] / canvasWidthDiff;
			mainThis.workoutConeLocation['topLeft']['posY'] = mainThis.workoutConeLocation['topLeft']['posY'] / canvasHeightDiff;
			mainThis.workoutConeLocation['topLeft']['posX'] = mainThis.workoutConeLocation['topLeft']['posX'] / canvasWidthDiff;
			mainThis.workoutConeLocation['bottomRight']['posY'] = mainThis.workoutConeLocation['bottomRight']['posY'] / canvasHeightDiff;
			mainThis.workoutConeLocation['bottomRight']['posX'] = mainThis.workoutConeLocation['bottomRight']['posX'] / canvasWidthDiff;
			mainThis.workoutConeLocation['bottomLeft']['posY'] = mainThis.workoutConeLocation['bottomLeft']['posY'] / canvasHeightDiff;
			mainThis.workoutConeLocation['bottomLeft']['posX'] = mainThis.workoutConeLocation['bottomLeft']['posX'] / canvasWidthDiff;
			
			if ( !mainThis.onDemand && window['updateWorkoutPosition'] ) { window['updateWorkoutPosition'](mainThis.id, 'workoutConeLocation', mainThis.workoutConeLocation); }
			
			if ( !mainThis.onDemand && mainThis.guestUser && !mainThis.hostVirtualOnMember )
				{
					if ( !window['preStreamingWhite'] ) 
						{
							window.showHideRoomSetup(true);
						}
						
					let addObject = {"sessionId": mainThis.currentUserData.sessionData.id,  "userId": mainThis.currentUserData.id, "event": "status", "eventType": "roomSetup", "details": JSON.stringify({"msg": "WAS Completed", "pos": mainThis.workoutConeLocation}), "timestamp": mainThis.Util.getCurrentTimestamp()};
					mainThis.sessionDataStore.addSessionData(addObject);
					
					if ( !window['preStreamingWhite'] ) { mainThis.whiteboard.splitRTMSend(mainThis.currentUserData['sessionData']['hostEmail'], 'finishWorkoutSetup'+mainThis.sep+JSON.stringify(mainThis.workoutConeLocation)+mainThis.sep+timeoutTime+mainThis.sep+'liveSession'+mainThis.sep+window['participantRejoined']); }
					else { mainThis.whiteboard.splitRTMSend(mainThis.currentUserData['sessionData']['hostEmail'], 'finishWorkoutSetup'+mainThis.sep+JSON.stringify(mainThis.workoutConeLocation)+mainThis.sep+timeoutTime+mainThis.sep+'preStreaming'+mainThis.sep+window['participantRejoined']); }
				}

					
			let addObject = {"sessionId": this.currentUserData.sessionData.id, "event": "status", "eventType": "passRoomSetup", "userId": this.currentUserData.id, "details": JSON.stringify({"msg": "User passed Room Setup"}), "timestamp": this.Util.getCurrentTimestamp()};
			this.sessionDataStore.addSessionData(addObject);
		}
		
	finishWorkoutSetupHost = (workoutConeObj) =>
		{
			var workoutZoneObj = workoutConeObj;
			if ( this.memberNoHostVirtual ) { workoutZoneObj = JSON.parse(workoutConeObj); }
			this.roomSetupInProgress = false;
			this.workoutConeLocation = workoutZoneObj;
			console.log('finishWorkoutSetup workoutConeLocation', this.workoutConeLocation);
			this.workoutAreaSetupDone = true;
			this.workoutProcessOver = true;
			this.viewCaptured = true;
			this.workoutAreaProcess = false;
			this.alreadyMeasured = true;
			
			this.whiteboard.globalActType = this.whiteboard.getActivityId(this.whiteboard.currentActivityName);
			this.whiteboard.doActivityEvents('activityBeforeStart');
			console.log('finishWorkoutSetup globalActType', this.whiteboard.globalActType);
			window.changeGlobalActType(this.whiteboard.globalActType, parseInt(this.id));
			this.whiteboard.setStatsIcons();
			
			if ( !this.memberNoHostVirtual )
				{
					if ( window.finishWorkoutSetupFlutter ) { window.finishWorkoutSetupFlutter(this.id); }
				}
		}
		
	finishRoomSetup = () => 
		{
			let videoElement = this.whiteboard.getVideoElement();
			//this.ctx5.drawImage(videoElement, 0, 0, videoElement.width/2, videoElement.height, 0, 0, this.roomSetupCanvas.width/2, this.roomSetupCanvas.height);
			if ( videoElement ) { this.ctx5.drawImage(videoElement, 0, 0, videoElement.width/2, videoElement.height, 0, 0, this.roomSetupCanvas.width/2, this.roomSetupCanvas.height); }
			this.whiteboard.pixelDataZero = this.ctx5.getImageData(0, 0, this.roomSetupCanvas.width, this.roomSetupCanvas.height).data;
			this.whiteboard.draw0 = true;
			this.allowRoomPicture = false;
			this.timerRunning = false;
			if ( !window['mediaPipeFirstTime'] )
				{
					this.whiteboard.showMessageInstruction('Calibrating...');
				}
			this.roomSetupCompleted = true;
			this.roomSetupStarted = false;
		
			var rmSd = new Image();
			rmSd.src = this.roomSetupCanvas.toDataURL("image/png");
			var roomSetupPicture = rmSd.src;
			console.log(roomSetupPicture, 'roomSetupPicture');
		
			if ( this.guestUser || this.onDemand || this.hostVirtual ) 
				{
					window['roomSetDone'] = true;
					window.checkRoomSetup();
					if ( window['preStreamingWhite'] )
						{
							this.uploadRoomPicture(this.roomSetupCanvas);
						}
						
					this.takeMeasure();
					this.trackerActions.setBackgroundImage(this.roomSetupCanvas);
					
					this.workoutAreaAudioPlayed = false;
					this.$('#partToolTip .tooltipSvg').addClass('d-none');
					this.$('#partToolTip .part_inner').html('');
					this.$('#progressBarRoom').addClass('d-none');
					this.$('#partToolTip .progressPercent').addClass('d-none');
					this.$('#partToolTip .progressText').addClass('d-none');
					//this.whiteboard.showMessageInstruction(this.globalEquipmentObject['workoutAreaSetupMessage'], false);
					
					if ( !this.hostVirtual )
						{
							let txt = this.globalEquipmentObject['hostRoomSuccess'];
							this.whiteboard.splitRTMSend(window['currentUserData']['sessionData']['hostEmail'], 'heightListener'+this.sep+1+this.sep+txt+this.sep+window['boxingType']);
						}
					
					this.workoutProcessStarting = true;
					
					var mainthis = this;
					//setTimeout(function() { mainthis.startWorkoutAreaSetup(); }, 1000);
				}
				
			this.roomSetupCanvas.remove();
		}
		
	finishMediaPipeCircle = () => 
		{
			if ( !window['alreadyClickedOnSkip'] && window.roomSetupNextStep ) { window.roomSetupNextStep(); }
			this.mediaCircleCompleted = true;
			if ( window.switchToNextRoomStep && window['mediaPipeFirstTime'] ) { window.switchToNextRoomStep(); }
			let addObject = {"sessionId": this.currentUserData.sessionData.id, "event": "status", "eventType": "passARprofile", "userId": this.currentUserData.id, "details": JSON.stringify({"msg": "User passed A/R Profile"}), "timestamp": this.Util.getCurrentTimestamp()};
			this.sessionDataStore.addSessionData(addObject);
		}
	
	createRoomSetupCanvas = () =>
		{
			this.roomSetupCanvas = document.createElement("canvas");
			this.roomSetupCanvas.width = 1280;
			this.roomSetupCanvas.height = 720;
			this.roomSetupCanvas.setAttribute('id', 'roomSetupCanvas'+this.id);
			document.body.appendChild(this.roomSetupCanvas); 
			console.log('roomSetupCanvas', this.roomSetupCanvas);
			
			this.ctx5 = this.roomSetupCanvas.getContext("2d");

			let videoElement = this.whiteboard.getVideoElement();
			this.whiteboard.drawCanvasFromVideoElement(videoElement, this.ctx5);
		}
		
	takeMeasure() 
		{
			if ( !this.alreadyMeasured )
				{
					var mainthis = this;
					if ( this.trackerActions.segBottom == 0 || this.trackerActions.segTop == 0 )
						{
							setTimeout(function() { mainthis.takeMeasure(); }, 100);
							return false;
						}
						
					//if ( this.useMediaPipe ) { this.whiteboard.poseDetection.getNewPose(this.whiteboard.bufferCanvas, function(mod) {  }); }
					
					var participantPx = this.trackerActions.segBottom - this.trackerActions.segTop;
					this.participantHeight2 = participantPx;
					
					console.log('participantPx', participantPx);
					console.log('participantHeight', this.participantHeight);
					
					this.pxPerMm = (this.participantHeight / (participantPx/1)).toFixed(2);
					
					var dist = parseFloat(((this.trackerActions.segBottom / (this.canvasHeight/2)) - 1).toFixed(2));
					
					this.partHeightDist = parseFloat(((this.trackerActions.segBottom / (this.canvasHeight/2)) - 1).toFixed(2));
					this.partTopDist = parseFloat(((this.trackerActions.segTop / (this.canvasHeight/2)) - 1).toFixed(2));
					
					let distCalc = participantPx / this.partHeightDist;
					
					this.partPxHeight = distCalc;
					
					console.log('dist', dist);
					
					this.pxPerMm = this.pxPerMm / ( 1 / dist );
					
					console.log(this.pxPerMm, 'PX PER MM');
					window['pxPerMm'] = this.pxPerMm;
					
					this.alreadyMeasured = true;
					
					this.heightCaptured = true;
					
					//window['SRTM'](window['currentUserData']['sessionData']['hostEmail'], 'heightResult'+sep+pxPerMm);
				}
				
			if ( !this.alreadyMeasured && this.heightFailedCounter < 3 )
				{			
					this.heightFailedCounter++;
					return 'fail';
				}
			else
				{
					if ( this.heightFailedCounter >= 3  )
						{
							this.whiteboard.pxPerMm = 2.5;
							console.log(this.whiteboard.pxPerMm, 'PX PER MM');
							this.alreadyMeasured = true;
							this.heightCaptured = true;
						}
					
					return 'success';
				}
		}

	uploadRoomPicture(useOtherCanvas) 
		{
			let mainthis = this;
			if ( !useOtherCanvas )
				{
					this.whiteboard.pauseDrawing = true;
					this.whiteboard.draw0 = false;
					this.whiteboard.stopClear = true;
				}
				
			if ( !this.guestUser )
				{
					this.$('#sessionCanvas'+this.id).addClass('agora_remove_pointer');
				}
			
			var videoElement = this.whiteboard.getVideoElement();
			
			this.whiteboard.ctx3.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
			
			let useCanvas = this.whiteboard.imageCanvas;
			if ( useOtherCanvas ) { useCanvas = useOtherCanvas; }
			
			if ( videoElement )
				{
					this.whiteboard.drawCanvasFromVideoElement(videoElement);
					
					setTimeout(function() {
						mainthis.roomSetupData = new Image();
						mainthis.roomSetupData.src = useCanvas.toDataURL("image/png");
						var roomSetupPicture = mainthis.roomSetupData.src;
						mainthis.roomSetupPicture = roomSetupPicture;
						
						setTimeout(function() {
							//window['uploadRoomImg']();

							if ( !mainthis.guestUser )
								{
									mainthis.$('#sessionCanvas'+mainthis.id).removeClass('agora_remove_pointer');
								}
							mainthis.whiteboard.draw0 = true;
							mainthis.whiteboard.pauseDrawing = false;
							mainthis.whiteboard.stopClear = false;
						}, 1000);
					}, 1000);
				}
		}
		
	startWorkoutAreaSetup = () => 
		{
			this.$('#partToolTip .tooltipImage').addClass('d-none');
			this.$('.tooltipText').removeClass('tool_tip_checkmark');
			this.$('.checkmark').removeClass('checkmark_inline');
			this.$('#heightToolTip').addClass('d-none');
			//this.whiteboard.showMessageInstruction(this.globalEquipmentObject['workoutAreaSetupMessage'], false);
			this.$('#walkToolImage').addClass('d-none');
			this.$('.walk_tool_text').html('');
			this.$('#partToolTip .tooltipSuccess').addClass('d-none');
			//this.workoutProcessStarting = false;
			
			//if ( window['audioType'] !== 'offAudio' && !this.workoutAreaAudioPlayed ) { this.whiteboard.soundPlay.stopAudio(); this.whiteboard.soundPlay.playAudio('workoutAreaSetup'); this.workoutAreaAudioPlayed = true; }
			if ( this.onDemand  ) { window['usingPose'] = true; }
			//this.workoutAreaProcess = true;
			this.whiteboard.globalActType = 'workoutAreaSetup';
			
			this.whiteboard.splitRTMSend(this.currentUserData['sessionData']['hostEmail'], 'startWAS'+this.sep);
			
			window.changeGlobalActType('workoutAreaSetup', parseInt(this.id));
			
			//window['showTrackerRectangle'] = true;
		}
		
	updateWorkoutConeLocation = (workoutConeLocation) =>
		{
			this.workoutConeLocation = JSON.parse(workoutConeLocation);
			if ( !this.onDemand )
				{
					let addObject = {"sessionId": this.currentUserData.sessionData.id,  "userId": this.currentUserData.id, "event": "status", "eventType": "roomSetup", "details": JSON.stringify({"msg": "Virtual Grid updated ( while doing WAS )"}), "timestamp": this.Util.getCurrentTimestamp()};
					this.sessionDataStore.addSessionData(addObject);
				}
		}
}

export default roomSetup;